export enum TypeOfAccessibilityStatement {
  ForClient = 'accessibility-statement-forClient',
  Regular = 'accessibility-statement-regular',
  Mobile = 'accessibility-statement-mobile',
}
